import { createFileRoute } from "@tanstack/react-router";
import { Files } from "@/components/Files";

function RouteComponent() {
  return <Files />;
}

export const Route = createFileRoute("/_authenticated/files/")({
  component: RouteComponent,
  staticData: { page: "files" },
});
